module.exports = __webpack_public_path__ + "b2e29ea6432e2ba46f355f4e5650b01f.png";